import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';

import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDividerModule } from '@angular/material/divider';
import { MatStepperModule } from '@angular/material/stepper';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatListModule } from '@angular/material/list';
import { MatCardModule } from '@angular/material/card';
import { MatTableModule } from '@angular/material/table';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTabsModule } from '@angular/material/tabs';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatMenuModule } from '@angular/material/menu';

import { GoogleIconComponent } from '../google-icon/google-icon.component';
import { AshgridAppellationComponent } from '../ashgrid-appellation/ashgrid-appellation.component';
import { EmailVerificationCtaVectorComponent } from '../email-verification-cta-vector/email-verification-cta-vector.component';
import { EmailVerificationCompleteVectorComponent } from '../email-verification-complete-vector/email-verification-complete-vector.component';
import { apiBaseURLProvider } from '../providers/api-base-url.provider';
import { environmentsProvider } from '../providers/environment.provider';
import { AuthenticationService } from '../services/authentication.service';
import { ScreenTrackingService, UserTrackingService , getAnalytics, provideAnalytics } from '@angular/fire/analytics';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatPaginatorModule } from '@angular/material/paginator';
import { TableComponent } from '../../../../console/src/app/table/table.component';
import { BarChartComponent } from '../../../../console/src/app/bar-chart/bar-chart.component';
import { NgxEchartsModule } from 'ngx-echarts';
import { PieChartComponent } from '../../../../console/src/app/pie-chart/pie-chart.component';
import { BackBreadCrumbComponent } from '../back-bread-crumb/back-bread-crumb.component';
import { MatRippleModule, provideNativeDateAdapter } from '@angular/material/core';
import { NoDataComponent } from '../no-data/no-data.component';
import { MatSelectModule } from '@angular/material/select';
import {MatCheckboxModule} from "@angular/material/checkbox";
import {MatChipsModule} from "@angular/material/chips";
import {MatButtonToggleModule} from "@angular/material/button-toggle";
import {MatSlideToggleModule} from "@angular/material/slide-toggle";
import {GoogleMapsModule} from "@angular/google-maps";
import {NumberSuffixPipe} from "../../../../console/src/app/pipes/number-suffix.pipe";
import {EnergyUnitPipe} from "../../../../console/src/app/pipes/energy-unit.pipe";
import {PowerUnitPipe} from "../../../../console/src/app/pipes/power-unit.pipe";
import {MatTooltipModule} from "@angular/material/tooltip";
import {NoCardComponent} from "../../../../console/src/app/no-card/no-card.component";
import {CdkCopyToClipboard, ClipboardModule} from "@angular/cdk/clipboard";
import {DragDropDirective} from "../../../../console/src/app/directives/drag-drop/drag-drop.directive";
import {MatAutocompleteModule} from "@angular/material/autocomplete";
import { AppleIconComponent } from '../apple-icon/apple-icon.component';

const declarations = [
  GoogleIconComponent,
  AshgridAppellationComponent,
  EmailVerificationCtaVectorComponent,
  EmailVerificationCompleteVectorComponent,
  TableComponent,
  BarChartComponent,
  PieChartComponent,
  BackBreadCrumbComponent,
  NoDataComponent,
  NumberSuffixPipe,
  EnergyUnitPipe,
  PowerUnitPipe,
  NoCardComponent,
  DragDropDirective,
  AppleIconComponent,
];

const modules = [
  RouterModule,
  ReactiveFormsModule,
  MatButtonModule,
  MatIconModule,
  MatFormFieldModule,
  MatInputModule,
  MatDividerModule,
  MatStepperModule,
  MatSnackBarModule,
  MatProgressBarModule,
  MatToolbarModule,
  MatListModule,
  MatCardModule,
  MatTableModule,
  MatPaginatorModule,
  NgxEchartsModule,
  MatDialogModule,
  MatRippleModule,
  MatTabsModule,
  MatDatepickerModule,
  MatMenuModule,
  MatSelectModule,
  MatCheckboxModule,
  MatChipsModule,
  MatButtonToggleModule,
  MatSlideToggleModule,
  MatDatepickerModule,
  MatTooltipModule,
  ClipboardModule,
  CdkCopyToClipboard,
  MatAutocompleteModule,
];

@NgModule({
  declarations: [...declarations],
  imports: [CommonModule, ...modules],
  exports: [CommonModule, ...modules, ...declarations],
  providers: [
    environmentsProvider,
    apiBaseURLProvider,
    AuthenticationService,
    NumberSuffixPipe,
    EnergyUnitPipe,
    PowerUnitPipe,
  ],
})
export class SharedModule {
  public static sharedProviders() {
    return [
      provideAnimationsAsync(),
      provideAnalytics(() => getAnalytics()),
      ScreenTrackingService,
      UserTrackingService,
      provideNativeDateAdapter(),
    ];
  }

  public static sharedRootModules() {
    return [
      BrowserAnimationsModule,
    ];
  }
}
